export default class Authenticator
{
    constructor( core )
    {
        if ( !Authenticator.instance ) {
            this.logger = core.getLogger()
            this.client = core.getClient()
            this.config = core.getConfig()
            this.eventManager = core.getEventManager()
            this.cryptoHelper = core.getCryptoHelper()
            this.ftsmp = core.getFriendlyTimestamp()
            this.store = core.getStore()
            this.router = core.getRouter()
            
            this.eventManager.add( 'on-session-timeout', () =>
            {
                this.forceLogout()
            } )
            
            this.eventManager.append( 'on-websocket-open', () =>
            {
                this._refreshUserInfo()
            } )
            
            Authenticator.instance = this
        }
        return Authenticator.instance
    }
    
    isUsernameAvailable( username )
    {
        return new Promise( ( resolve ) =>
        {
            
            this.client.request( {
                    method:       'users.isUsernameAvailable',
                    looseSession: true,
                    username:     username
                } )
                .then( ( response ) =>
                {
                    switch ( response.available ) {
                        case true:
                            return resolve( true )
                        default:
                            return resolve( false )
                    }
                } )
                .catch( ( err ) =>
                {
                    this.eventManager.dispatch( 'on-websocket-error', { code: 'E_GENERIC', error: err } )
                    return resolve( false )
                } )
            
        } )
    }
    
    /*eslint-disable*/
    register( user )
    {
        return new Promise( ( resolve ) =>
        {
            
            let message = {
                method:       'users.register',
                looseSession: true,
                username:     user.login,
                passwordHash: user.passwordHash,
                platformUrl:  this.config.baseUri,
                name:         this.cryptoHelper.encryptForServer( user.name ),
                email:        this.cryptoHelper.encryptForServer( user.email ),
                dateBirthday: this.ftsmp.mysqlDate( user.dateBirthday )
            }
            
            this.client.request( message )
                .then( () =>
                {
                    
                    this.eventManager.dispatch( 'on-ui-message', {
                        type:    'success',
                        title:   'Willkommen bei lovepod, ' + user.name,
                        message: 'Um deine Registrierung abzuschließen, überprüfe bitte dein E-Mail-Postfach: Wir haben dir einen Bestätigungslink zukommen lassen.'
                    } )
                    
                    return resolve( true )
                    
                } )
                .catch( ( err ) =>
                {
                    this.eventManager.dispatch( 'on-websocket-error', { code: 'E_GENERIC', error: err } )
                    return resolve( false )
                } )
            
        } )
    }
    
    tryLogin( username, passwordHash )
    {
        return new Promise( ( resolve ) =>
        {
            
            this.client.request( {
                    method:       'users.tryLogin',
                    looseSession: true,
                    username:     username,
                    passwordHash: passwordHash
                } )
                .then( response =>
                {
                    
                    this.store.commit( 'setIdSession', response.idSession );
                    this.store.commit( 'setUsername', response.result.username );
                    this.store.commit( 'setIdUser', response.result.id );
                    this.store.commit( 'setAuthorized', true )
                    
                    this.client.request( {
                            method:  'users.getFullUserInfo',
                            id_user: response.result.id
                        } )
                        .then( infoResponse =>
                        {
                            
                            this.store.commit( 'setLevel', infoResponse.result.level );
                            this.router.push( '/dashboard' )
                            return resolve( true )
                            
                        } )
                        .catch( () =>
                        {
                        } )
                    
                } )
                .catch( () =>
                {
                    this.eventManager.dispatch( 'on-ui-message', {
                        type:    'error',
                        title:   'Das hat leider nicht funktioniert',
                        message: 'Möglicherweise hast du dich vertippt? Überprüfe deine Angaben und versuch es gleich nochmal.<br/><strong>Hinweis</strong>: Wenn du deine E-Mail-Adresse noch nicht bestätigt hast, überprüfe bitte dein Postfach und klicke den Bestätigungslink an.'
                    } )
                    return resolve( false )
                } )
            
        } )
    }
    
    _refreshUserInfo()
    {
        
        if ( this.store.getters.authorized ) {
            
            this.client.request( {
                    method:  'users.getFullUserInfo',
                    id_user: this.store.getters.idUser
                } )
                .then( infoResponse =>
                {
                    
                    this.store.commit( 'setLevel', infoResponse.result.level );
                    
                } )
                .catch( () =>
                {
                } )
            
        }
        
    }
    
    forceLogout()
    {
        
        this.store.commit( 'setIdSession', false );
        this.store.commit( 'setUsername', false );
        this.store.commit( 'setIdUser', false );
        this.store.commit( 'setAuthorized', false )
        
        this.eventManager.dispatch( 'on-ui-message', {
            type:    'warning',
            title:   'Du wurdest automatisch abgemeldet',
            message: 'Aufgrund längerer Inaktivität wurdes du automatisch abgemeldet. Melde dich bitte erneut an.'
        } )
        
        this.router.push( '/' )
        
    }
    
    tryLogout()
    {
        return new Promise( ( resolve ) =>
        {
            
            this.client.request( {
                    method:       'users.tryLogout',
                    looseSession: true,
                    session:      this.store.getters.idSession
                }, 2000 )
                .then( () =>
                {
                } )
                .catch( () =>
                {
                } )
                .finally( () =>
                {
                    
                    this.store.commit( 'setIdSession', false );
                    this.store.commit( 'setUsername', false );
                    this.store.commit( 'setIdUser', false );
                    this.store.commit( 'setAuthorized', false )
                    
                    this.eventManager.dispatch( 'on-ui-message', {
                        type:  'success',
                        title: 'Bis demnächst!'
                    } )
                    
                    this.router.push( '/' )
                    return resolve()
                    
                } )
            
        } )
    }
    
}